export default __webpack_public_path__ + "static/media/footer.b8d37ef7.jpg";